var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          staticClass: "pb-2",
          class: { "px-3": _vm.$vuetify.breakpoint.smAndUp },
          attrs: {
            justify: "start",
            "no-gutters": _vm.$vuetify.breakpoint.smAndUp,
          },
        },
        [
          _c(
            "v-chip-group",
            {
              model: {
                value: _vm.selection,
                callback: function ($$v) {
                  _vm.selection = $$v
                },
                expression: "selection",
              },
            },
            _vm._l(_vm.selects, function (chip, name, idx) {
              return _c(
                "v-chip",
                {
                  key: chip.name,
                  class: [
                    //'primary primary--text v-chip--outlined shadow-blue',
                    "font-weight-bold v-chip--outlined soli-grey",
                    idx == 0 && _vm.$vuetify.breakpoint.xs ? "ml-6" : "mx-1",
                    idx == Object.keys(_vm.selects).length - 1 &&
                    _vm.$vuetify.breakpoint.xs
                      ? "mr-6"
                      : "mx-1",
                    idx == 1 && !_vm.form.instrument ? "hide" : null,
                  ],
                  attrs: {
                    close: !!(chip.clearable && _vm.form[name]),
                    "close-icon": "clear",
                    value: chip.name,
                    id: chip.name,
                    outlined: "",
                    small: "",
                    disabled: chip.disabled,
                    ripple: false,
                  },
                  on: {
                    "click:close": function ($event) {
                      ;[(_vm.form[name] = null), _vm.resetOptions()]
                    },
                  },
                  model: {
                    value: chip.show,
                    callback: function ($$v) {
                      _vm.$set(chip, "show", $$v)
                    },
                    expression: "chip.show",
                  },
                },
                [_vm._v(_vm._s(chip.display()))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.instrument
        ? _c("SoliDateScroll", {
            ref: "date",
            attrs: {
              error: _vm.errors.starts_at,
              future: true,
              events: _vm.searchAssignments.map((e) =>
                _vm.globalMomentYMD(e.starts_at)
              ),
              select: false,
              intervals: _vm.assignmentIntervals,
              intervalsLoading: _vm.apiLoading,
              loading: _vm.assignmentsLoading,
              selectedInstrument: _vm.form.instrument?.id,
              selectedLocation: _vm.form.location,
              floating: false,
              simStudentView: "",
            },
            on: {
              input: function ($event) {
                return _vm.selectDate($event)
              },
              inputTime: function ($event) {
                return _vm.selectTime($event)
              },
            },
            model: {
              value: _vm.form.startDate,
              callback: function ($$v) {
                _vm.$set(_vm.form, "startDate", $$v)
              },
              expression: "form.startDate",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.form.instrument
        ? _c(
            "v-container",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    block: "",
                    outlined: "",
                    rounded: "",
                    color: "#e0e0e0",
                  },
                  on: {
                    click: function ($event) {
                      ;[
                        (_vm.selects["instrument"].show = true),
                        (_vm.selection = "instrument"),
                      ]
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "soli-grey flex align-center justify-center",
                    },
                    [
                      _vm._v("\n                Instrument "),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("keyboard_arrow_down"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selection
        ? _c("SoliResponsiveDialog", {
            ref: "selection",
            attrs: { close: false },
            on: {
              reset: function ($event) {
                ;[
                  (_vm.selects[_vm.selection].show = false),
                  (_vm.selection = null),
                ]
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "px-0",
                          class: { "py-3": _vm.$vuetify.breakpoint.xs },
                        },
                        [
                          _c(
                            _vm.selects[_vm.selection].comp,
                            _vm._b(
                              {
                                tag: "component",
                                on: {
                                  input: function ($event) {
                                    return _vm.resetOptions()
                                  },
                                },
                                model: {
                                  value: _vm.form[_vm.selection],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, _vm.selection, $$v)
                                  },
                                  expression: "form[selection]",
                                },
                              },
                              "component",
                              { ..._vm.selects[_vm.selection].props() },
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2054694486
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.aiComplete
        ? _c("SoliSnack", {
            attrs: { text: _vm.aiComplete },
            on: {
              hide: function ($event) {
                _vm.aiComplete = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }